/**
 * permissionsHelper.js
 * Gestion des droits d'accès pour les informations confidentielles
 */

/**
 * Vérifier si l'utilisateur peut voir les informations confidentielles (proprio, adresse exacte)
 * @param {Object} userProfile - Profil utilisateur
 * @param {Object} agencySettings - Paramètres agence
 * @returns {boolean}
 */
export function canViewConfidential(userProfile, agencySettings) {
  // Si pas de userProfile, par défaut on refuse
  if (!userProfile) return false;
  
  // Vérifier si l'utilisateur est admin
  if (userProfile.role === 'admin') return true;
  if (userProfile.isAdmin === true) return true;
  
  // Vérifier les permissions explicites
  if (userProfile.permissions) {
    if (userProfile.permissions.viewConfidential === true) return true;
    if (userProfile.permissions.includes?.('view_confidential')) return true;
  }
  
  // Par défaut, si l'utilisateur est connecté et membre de l'agence, il a accès
  // (C'est un outil interne agent immobilier)
  if (userProfile.uid || userProfile.id) {
    return true;
  }
  
  return false;
}

export default {
  canViewConfidential
};
